// awsconfig.ts
export const SYSTEM_TITLE = '取引支援システム'

const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: 'ap-northeast-1_FcDXZd8lc',
      userPoolClientId: '2788tdn19gegtji0s14vs6bsbb',
      identityPoolId: 'ap-northeast-1:5422f781-dbc5-4832-8d09-1cd9ab070b04', // Optional
    },
    loginWith: {
      username: true,
      email: true,
      phone: false,
    },
  },
  API: {
    REST: {
      'tss-stg': {
        endpoint: 'https://9l8ds2c80b.execute-api.ap-northeast-1.amazonaws.com/v1',
        region: 'ap-northeast-1',
      },
    },
  },
  SystemTitle: SYSTEM_TITLE
};

export default awsConfig;
